import {
  Grid,
  Theme,
  withStyles,
  WithStyles,
  withWidth
} from '@material-ui/core'
import { WithWidth } from '@material-ui/core/withWidth'
import classNames from 'classnames'
import { Fragment } from 'react'
import { isSmallScreen } from '../../../libs/screenSize'
import i18n from '../../../translations/i18n'
import { afterHalfPoint } from '../../../utils/arrays'
import { CustomChip } from '../Chips'

const styles = ({ breakpoints }: Theme) => ({
  grid: {
    display: 'grid',
    gridGap: '0.1rem',
    gridAutoFlow: 'column',
    [breakpoints.down('sm')]: {
      gridAutoFlow: 'unset'
    }
  },
  firstHalf: {
    gridColumnStart: 1
  },
  secondHalf: {
    gridColumnStart: 2
  }
})

interface PropertyListProps extends WithStyles, WithWidth {
  informationOrder: string[]
  data: any
  translationPath: string
  onlyShowTrue?: boolean
}

/** top down list that is split into two same size columns */
const ChipList = ({
  informationOrder,
  data,
  translationPath,
  classes,
  width,
  onlyShowTrue
}: PropertyListProps) => (
  <Grid container direction='column' spacing={0} className={classes.grid}>
    {informationOrder &&
      informationOrder.map((key: string, index: number) => {
        const showValue = onlyShowTrue ? data[key] : true
        return (
          <Fragment key={key}>
            {showValue && (
              <Grid
                item
                sm={3}
                // using secondHalf css to split into two columns
                className={classNames(
                  !afterHalfPoint(informationOrder, index) &&
                    !isSmallScreen(width) &&
                    classes.firstHalf,
                  afterHalfPoint(informationOrder, index) &&
                    !isSmallScreen(width) &&
                    classes.secondHalf
                )}
              >
                <CustomChip
                  label={i18n.t(`${translationPath}.${key}`)}
                  value={data[key]}
                />
              </Grid>
            )}
          </Fragment>
        )
      })}
  </Grid>
)

export default withStyles(styles)(withWidth()(ChipList))
